import { styled } from '@mui/material/styles';
import { Box, Grid } from '@mui/material';
import BackgroundImage from '../../public/images/login/background2.webp';
import TeacherBackgroundImage from '../../public/images/login/teacher-background.jpg';

export const StyledGrid = styled(Grid)(({ theme }) => ({
	overflowY: 'auto',
	overflowX: 'hidden',
	WebkitOverflowScrolling: 'touch',
	marginTop: 'env(safe-area-inset-top)',
	height: 'calc(100vh - env(safe-area-inset-top))',
	paddingTop: 'env(safe-area-inset-top)'
}));

export const StyledImageSection = styled(Grid)(({ theme, isteacher }) => ({
	backgroundColor: 'white',
	backgroundImage: `url(${isteacher === 'true' ? TeacherBackgroundImage : BackgroundImage})`,
	backgroundRepeat: 'no-repeat',
	backgroundSize: 'cover',
	backgroundPosition: 'right',
	minHeight: '25vh',
	height: 'auto',
	display: 'block',
	[theme.breakpoints.up('md')]: {
		display: 'block',
		height: '100vh'
	}
}));

export const StyledLoginSection = styled(Grid)({
	overflowY: 'auto',
	overflowX: 'hidden',
	WebkitOverflowScrolling: 'touch',
	paddingBottom: 'env(safe-area-inset-bottom)'
});

export const StyledBox = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'start',
	justifyContent: 'start',
	padding: '0px 24px',
	marginLeft: 'auto',
	marginRight: 'auto',
	[theme.breakpoints.up('sm')]: {
		padding: '0px 56px'
	}
}));
